// Minimal promise wrapper around IndexedDB for the offline cache, outbox and queued files.
const DB_NAME = "notelosh-offline";
const STORES = ["cache", "outbox", "blobs"];
let dbPromise = null;

function open() {
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains("cache")) db.createObjectStore("cache");
        if (!db.objectStoreNames.contains("blobs")) db.createObjectStore("blobs");
        if (!db.objectStoreNames.contains("outbox")) db.createObjectStore("outbox", { keyPath: "id", autoIncrement: true });
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }
  return dbPromise;
}

async function run(store, mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, mode);
    const req = fn(tx.objectStore(store));
    tx.oncomplete = () => resolve(req?.result);
    tx.onerror = () => reject(tx.error);
  });
}

export const idb = {
  get: (store, key) => run(store, "readonly", (s) => s.get(key)),
  set: (store, key, val) => run(store, "readwrite", (s) => (store === "outbox" ? s.put(val) : s.put(val, key))),
  add: (store, val) => run(store, "readwrite", (s) => s.add(val)),
  del: (store, key) => run(store, "readwrite", (s) => s.delete(key)),
  all: (store) => run(store, "readonly", (s) => s.getAll()),
  keys: (store) => run(store, "readonly", (s) => s.getAllKeys()),
  clear: (store) => run(store, "readwrite", (s) => s.clear()),
};
export { STORES };
